
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

import logo from '../img/logo/ddd.png';
// import logo from '../img/logo/jsnhsee.JPG';
import IIALogo from '../img/IIA_LOGO_White-for-website_v3.png'

import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          {/* Logo and Description */}
          <div className=" col-md-3 logo d-flex align-items-center">
            <div className="row">
              <div className='col-md-12'>
                <div className="row" style={{ marginTop: "-17px", }}>
                  <div className="col-2">
                    <img alt="logo" src={logo} style={{ maxHeight: '135px', marginLeft: "30px", marginTop: "-20px" }} />
                    {/* <h1 style={{color:"rgb(254 153 0)", textAlign:"center",marginLeft:'50px',marginTop:'23px',marginBottom:'20px',fontSize:'33px' }}>DREBCON</h1>
                 */}
                  </div>
                  <div className="col-10">
                    <span style={{ padding: '5px', paddingTop: '10px' }}>
                      {/* <p style={{ fontSize: '22px', color: 'rgb(251 145 0)', fontWeight: '600' }} >International Institute of Automate</p> */}
                      {/* <p style={{ fontSize: '13px' }}>(Powered by Envision Intigrated Services)</p> */}
                    </span>
                  </div>
                </div>

              </div>
              {/* <div className='col-md-12'>
                <img alt="logo" src={logo} style={{ maxHeight: '130px', paddingBottom: '20px' }} />
              </div> */}
              <div className="col-md-12">
                <div style={{ color: "white", padding: '0px 31px',textAlign:"justify", marginTop:"-29px" }}>At DREBCON, we are more than just consultants—we are strategic enablers of transformation. With deep expertise across compliance, cybersecurity, and AI-driven innovation, we empower businesses to navigate complex regulatory landscapes, fortify digital ecosystems, and harness cutting-edge technology for sustainable growth. Whether it's ISO compliance, data security, or AI-enabled IT & OT transformation, we deliver future-proof solutions that drive efficiency, resilience, and competitive advantage. Join us in redefining industry standards and building a smarter, more secure future.</div>
                <div className="s-social">
                  {/* Social Icons */}
                  <a href="#"><span className="ti-facebook"></span></a>
                  <a href="#"><span className="ti-linkedin"></span></a>
                  <a href="#"><span className="ti-instagram"></span></a>
                  <a href="#"><span className="ti-youtube"></span></a>
                  <Link to="#" target="_blank">
                    <span className="ti-twitter" style={{ fontSize: "20px" }}></span>
                  </Link>
                </div>
              </div>
            </div>



          </div>

          {/* Courses Section */}  
          <div className="col-md-3 text-left mb-3">
            <h5 className="heading">INDUSTRIES</h5>
            <div className="s-address">
              <div className="detail">
                <Link to="/aerospace">- Aerospace & Defence</Link>
              </div>
              <div className="detail">
                <Link to="/automotivemobility">- Automotive, Rail & Next-Gen Mobility  </Link>
              </div>
              <div className="detail">
                <Link to="/energy">- BFSI</Link>
              </div>

              <div className="detail">  
                <Link to="/energyPagedata">- Energy & Infrastructure</Link>
              </div>
              <div className="detail">
                <Link to="/healthcare">- Healthcare & Life Sciences  </Link>
              </div>

              <div className="detail">
                <Link to="/manufacturingpage">- Manufacturing</Link>
              </div>
              <div className="detail">
                <Link to="/communication">- Media & Communication </Link>
              </div>

            

            </div>
          </div>

          {/* Useful Links */}
          <div className="col-md-2 text-left mb-3">
            <h5 className="heading">RESOURCES</h5>
            <div className="s-address">
              <div className="detail">
                <Link to="/">- Blogs</Link>
              </div>
              <div className="detail">
                <Link to="/">- Case Studies</Link>
              </div>
              <div className="detail">
                <Link to="/">- Documents</Link>
              </div>
              <div className="detail">
                <Link to="/">- Whitepaper</Link>
              </div>
              {/* <div className="detail">
                <Link to="/">- Contact Us</Link>
              </div> */}
            </div>
          </div>

          {/* Get In Touch */}
          <div className="col-md-4 mb-3">
            <h5 className="heading">GET IN TOUCH</h5>
            <div className="s-address">
              <div className="detail">
                <FontAwesomeIcon icon={faEnvelope} style={{ paddingRight: '10px' }} />
                sales@drebcon.com
              </div>

              <div className="detail">
                <FontAwesomeIcon icon={faPhone} style={{ paddingRight: '10px' }} />
                +91 9063595984
              </div>
              <div className="detail">
                <FontAwesomeIcon icon={faPhone} style={{ paddingRight: '10px' }} />
                +91 9063595986
              </div>
              <h5 style={{color:"#ec7322",marginBottom:"10px"}}>CORPORATE OFFICE ADDRESS</h5>
               <div className="detail">
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ paddingRight: '10px' }} />
                DREBCON Global Services Private Limited
                #913, Manjeera Trinity Corporate, 9th floor, Office No.913, KPHB,Hyderabad,Telangana, India - 500085
              </div>
              <h5 style={{color:"#ec7322",marginBottom:"10px"}}>REGISTERED OFFICE ADDRESS</h5>
              <div className="detail">
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ paddingRight: '10px' }} />
                DREBCON Global Services Private Limited<br />
                 PN-52B, Spring Valley, Block-1, Kondapur, K.V.Rangareddy, K.V.Rangareddy-500084, Telangana, India
              </div>
                <h5 style={{color:"#ec7322",marginBottom:"10px"}}>USA OFFICE: </h5>
              <div className="detail">
                <FontAwesomeIcon icon={faMapMarkerAlt} style={{ paddingRight: '10px' }} /><strong>DREBCON INC</strong><br />
5900 Balcones DR, STE 15395<br />
Austin, TX 78731
              </div>

            

            </div>
          </div>

          {/* Our Location */}
          {/* <div className="col-md-2 mb-3">
            <h5 className="heading">Our Location</h5>
            <div className="contact-info" style={{ color: '#fff' }}>
              <div className="location mb-3">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                <> Bangalore</>
                <p style={{ fontSize: '14px', margin: 0, textAlign: 'left' }}>1596, 20th Main Road, Agara Village, 1st Sector, HSR Layout, Bengaluru, Karnataka, <br /> india - 560102</p>
              </div>
              <div className="location mb-3">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                <> Pune</>
                <p style={{ fontSize: '14px', margin: 0, textAlign: 'left' }}>Suratwala Mark, 8th Floor, Office No. 810, Wakad Road, Pune, Maharashtra - 411057</p>
              </div>
            </div>
          </div> */}
          
        </div>

        {/* Subfooter */}
        <div className="row mt-3">
          <div className="col-12 text-center">
            <div className="subfooter">
              <div className="copyright">
                <p>Copyright © 2025, All Rights Reserved To  <span style={{ fontWeight: '700' }}> DREBCON</span></p>
              </div>
              <a className="terms" href="#" style={{ color: '#fff' }}>
                Terms of Use | Privacy Environmental Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
